import React, { useEffect, useState } from "react";
import {
  LinearProgress,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Box,
  Menu,
  MenuItem,
  ListItemText,
  Typography,
  TablePagination,
  TableFooter,
  IconButton,
  CircularProgress,
  ListItemIcon,
} from "@mui/material";
import http from "../../../utils/http";
import { errorToastMessage, toastMessage } from "../../../utils/toast";
import {
  NoDataContainer,
  pageSize,
  paginationLabel,
  StyledTableCell,
  TableBorderRadiusTopLeftRight,
  TablePaginationStyle,
} from "../../Common/styles/table";
// import { Edit, MoreVert } from "@mui/icons-material";
import { AxiosResponse } from "axios";
import { CustomStatusChip } from "../../Common/UI/StatusTag";
// import { useNavigate } from "react-router-dom";
import { DateTime } from "luxon";
import { MoreVert } from "@mui/icons-material";
import AddNewUserModal from "./AddNewUserModal";

const statusMap: any = {
  active: { label: "Active", color: "#03543F", bgColor: "#DEF7EC" },
  invited: { label: "Inactive", color: "#9B1C1C", bgColor: "#FDE8E8" },
};

type Props = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  canEdit: boolean;
};

const UsersList = ({
  searchText,
  showModal,
  setShowModal,
  setSearchText,
  canEdit,
}: Props) => {
  const [loading, setLoading] = useState(true);
  const [toggleLoader, setToggleLoader] = useState(false);
  const [studyData, setStudyData] = useState<any>([]);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  // const [sortOrder, setSortOrder] = useState("");
  // const [sortColumn, setSortColumn] = useState("");
  const [menuLoader, setMenuLoader] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [usersCount, setUsersCount] = useState<number>(0);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // const navigate = useNavigate();

  useEffect(() => {
    const fetchStudyData = async () => {
      try {
        setLoading(true);
        let url = `/platform/users/list?page=${page + 1}&size=${pageSize}`;
        if (searchText) {
          url += `&query=${searchText}`;
        }

        const res: AxiosResponse = await http.get(url);
        const data = res.data?.data?.rows;
        const newData = data?.map((item: any) => ({
          id: item?.id,
          userId: item?.userId || "",
          firstName: item?.user?.firstName || "-",
          lastName: item?.user?.lastName || "-",
          phoneNumber: item?.name || "-",
          email: item?.user?.email || "-",
          status: item?.status || "-",
          date: item?.createdAt
            ? DateTime.fromISO(item?.createdAt).toFormat("dd/MM/yy")
            : "-",
        }));

        setStudyData(newData || []);
        setUsersCount(res.data?.data?.count || 0);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        errorToastMessage(err as Error);
      }
    };
    fetchStudyData();
  }, [searchText, toggleLoader, page]);

  const refreshPage = () => {
    setToggleLoader((prev) => !prev);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>, row: any) => {
    setSelectedRow(row);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  // const handleCellClick = (id: string) => {
  //   navigate(`/app/users/details/${id}`);
  // };
  // const openModal = () => {
  //   setShowModal(true);
  //   setAnchorEl(null);
  // };

  const closeModal = () => {
    setShowModal(false);
    setSelectedRow(null);
  };

  // const modifySearchTerm = useMemo(
  //   () =>
  //     debounce((val) => {
  //       setSearchText(val);
  //     }, 500),
  //   [setSearchText]
  // );
  const handlePageChange = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const reinviteUser = async () => {
    try {
      setMenuLoader(true);
      const body = {
        userId: selectedRow?.userId,
      };
      const res: AxiosResponse = await http.post(
        `/platform/users/reinvite`,
        body
      );
      toastMessage("success", res.data.message);
      setMenuLoader(false);
      handleMenuClose();
      refreshPage();
    } catch (err) {
      setMenuLoader(false);
      errorToastMessage(err as Error);
    }
  };

  return (
    <Box sx={{ p: 2, backgroundColor: "#fff", borderRadius: "10px" }}>
      {/* <Box sx={SearchBox}>
        <TextField
          sx={{ width: "70%" }}
          variant="outlined"
          placeholder="Search"
          defaultValue={searchText}
          onChange={(e) => modifySearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <GridSearchIcon sx={{ color: "#637E85" }} />
              </InputAdornment>
            ),
          }}
        />
      </Box> */}
      <Table sx={TableBorderRadiusTopLeftRight}>
        <TableHead>
          <TableRow>
            <StyledTableCell>First Name</StyledTableCell>
            <StyledTableCell>Last Name</StyledTableCell>
            <StyledTableCell>Email</StyledTableCell>
            {/* <StyledTableCell>Phone Number</StyledTableCell> */}
            {/* <StyledTableCell>Emp ID</StyledTableCell> */}
            <StyledTableCell>Status</StyledTableCell>
            <StyledTableCell />
          </TableRow>
        </TableHead>
        {!loading && studyData?.length > 0 && (
          <>
            <TableBody>
              {studyData?.map((row: any) => (
                <TableRow key={row?.id}>
                  <StyledTableCell
                  // onClick={() => handleCellClick(row?.id)}
                  // sx={{ cursor: "pointer" }}
                  >
                    {row?.firstName}
                  </StyledTableCell>
                  <StyledTableCell
                  // onClick={() => handleCellClick(row?.id)}
                  // sx={{ cursor: "pointer" }}
                  >
                    {row?.lastName}
                  </StyledTableCell>
                  <StyledTableCell>{row?.email}</StyledTableCell>
                  {/* <StyledTableCell>{row?.phoneNumber}</StyledTableCell> */}
                  {/* <StyledTableCell>{row?.date}</StyledTableCell> */}
                  <StyledTableCell>
                    <CustomStatusChip
                      label={statusMap[row?.status]?.label}
                      color={statusMap[row?.status]?.color}
                      bgColor={statusMap?.[row.status]?.bgColor}
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {row?.status === "invited" && (
                      <IconButton onClick={(e) => handleMenuClick(e, row)}>
                        <MoreVert />
                      </IconButton>
                    )}
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
            {usersCount > pageSize && (
              <TableFooter>
                <TableRow>
                  <TablePagination
                    sx={TablePaginationStyle}
                    count={usersCount}
                    page={page}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[pageSize]}
                    onPageChange={handlePageChange}
                    labelDisplayedRows={paginationLabel}
                  />
                </TableRow>
              </TableFooter>
            )}
          </>
        )}
      </Table>
      {!loading && studyData.length === 0 && (
        <NoDataContainer>
          <Typography variant="body1" color="gray">
            No Data
          </Typography>
        </NoDataContainer>
      )}
      {loading && (
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      )}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            maxHeight: "400px",
            width: "20ch",
          },
        }}
      >
        <MenuItem disabled={menuLoader} onClick={reinviteUser}>
          <ListItemText>Reinvite</ListItemText>
          {menuLoader && (
            <ListItemIcon>
              <CircularProgress size={18} sx={{ ml: 1 }} />
            </ListItemIcon>
          )}
        </MenuItem>
      </Menu>

      {showModal && (
        <AddNewUserModal
          showModal={showModal}
          closeModal={closeModal}
          data={selectedRow}
          refreshPage={refreshPage}
        />
      )}
    </Box>
  );
};

export default UsersList;
